<template>
  <div class="card" style="border: none" :id="isPrint ? 'print' : ''">
    <div
      class="card-body"
      :style="isPrint ? `height: ${height}; width: ${width};` : ''"
    >
      <div
        :class="[
          'invoice-watermark',
          'tone-' + (data.document_status_tone || 'danger'),
        ]"
      >
        {{ data.document_watermark }}
      </div>
      <div class="invoice-document-meta">
        <span
          :class="[
            'invoice-status-stamp',
            'tone-' + (data.document_status_tone || 'danger'),
          ]"
          >{{ data.document_status_label || "BELUM DIBAYAR" }}</span
        >
        <span v-if="data.is_copy" class="invoice-copy-stamp">SALINAN</span>
      </div>
      <div class="row justify-content-between align-items-center">
        <div class="col-8">
          <table>
            <div style="font-size: 14pt">
              <strong>{{
                data.document_status === "draft"
                  ? "Proforma Invoice"
                  : "Invoice"
              }}</strong>
            </div>
            <tr>
              <td style="width: 100px">Nomor</td>
              <td style="width: 9px">:</td>
              <td>{{ data.invoice_number || data.id }}</td>
            </tr>
            <tr>
              <td>Tanggal</td>
              <td style="width: 9px">:</td>
              <td>{{ data.display_created_at }}</td>
            </tr>
            <tr>
              <td>Nama Pasien</td>
              <td style="width: 9px">:</td>
              <td>{{ data.patient_name }}</td>
            </tr>
            <tr v-if="data.sub_patient_id != null">
              <td>Nama Sub Pasien</td>
              <td style="width: 9px">:</td>
              <td>{{ data.sub_patient_name }}</td>
            </tr>
            <tr>
              <td>Nomor HP</td>
              <td style="width: 9px">:</td>
              <td>{{ data.patient_mobile_phone }}</td>
            </tr>
            <tr>
              <td>Dokter</td>
              <td style="width: 9px">:</td>
              <td>{{ data.doctor_name }}</td>
            </tr>
          </table>
        </div>
        <div class="col">
          <ImageComponent place="logo-invoice"></ImageComponent>
          <div class="font-weight-light" style="font-size: 10.7px">
            {{ setting.clinic_address }}
          </div>
          <div class="font-weight-light" style="font-size: 10.7px">
            {{ setting.phone }}
          </div>
        </div>
      </div>
      <div class="invoice-content">
        <div class="row">
          <div class="col-md-12">
            <b-table striped hover small :items="items" :fields="fields">
              <template #table-colgroup="scope">
                <col v-for="field in scope.fields" :key="field.key" />
              </template>
              <template #cell(price)="data">
                {{
                  "Rp " +
                  parseInt(
                    parseInt(data.item.price) -
                      parseInt(data.item.promo_amount) +
                      data.item.discount_amount
                  ).toLocaleString("id-ID")
                }}
              </template>
              <template #cell(discount)="data">
                <span
                  >Rp
                  {{
                    `${parseInt(data.item.discount_amount).toLocaleString(
                      "id-ID"
                    )} ${
                      data.item.discount_type == 1 &&
                      (data.item.discount_amount != 0 ||
                        data.item.discount_percentage != 0)
                        ? `(${parseInt(data.item.discount_percentage)})%`
                        : ""
                    }`
                  }}</span
                >
              </template>
              <template #cell(subtotal)="data">
                {{ "Rp " + parseInt(data.item.total).toLocaleString("id-ID") }}
              </template>
            </b-table>
          </div>
        </div>
        <div class="invoice-closing-grid">
          <div class="invoice-notes">
            <span class="font-weight-bold d-block">Catatan :</span>
            <div class="invoice-notes-box">
              <span>{{ data.notes }}</span>
            </div>
          </div>
          <table v-if="showSummary" class="invoice-summary">
            <tr>
              <td style="width: 150px">Subtotal</td>
              <td class="font-weight-bold" style="width: 25px">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  parseInt(data.total_amount).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
            <tr>
              <td>Diskon</td>
              <td class="font-weight-bold" style="width: 25px">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  parseInt(data.discount).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
            <tr>
              <td>Biaya Tambahan</td>
              <td class="font-weight-bold" style="width: 25px">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  parseInt(data.surcharge).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
            <tr v-if="numberValue(data.paid_amount) > 0">
              <td>Terbayar</td>
              <td class="font-weight-bold">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  numberValue(data.paid_amount).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
            <tr v-if="numberValue(data.deposit_applied) > 0">
              <td>Deposit</td>
              <td class="font-weight-bold">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  numberValue(data.deposit_applied).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
            <tr v-if="numberValue(data.refunded_amount) > 0">
              <td>Refund</td>
              <td class="font-weight-bold">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  numberValue(data.refunded_amount).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
            <tr v-if="numberValue(data.unpaid_amount) > 0">
              <td>Sisa</td>
              <td class="font-weight-bold">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  numberValue(data.unpaid_amount).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
            <tr v-if="data.coupon_amount">
              <td>Kupon</td>
              <td class="font-weight-bold" style="width: 25px">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">
                  {{ parseInt(data.coupon_amount).toLocaleString("id-ID") }}
                </span>
              </td>
            </tr>
            <tr class="invoice-total-row">
              <td>Total</td>
              <td style="width: 25px">Rp</td>
              <td class="text-right">
                <span class="font-weight-bold">{{
                  parseInt(data.final_amount).toLocaleString("id-ID")
                }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="invoice-signature">
        <div class="invoice-signature__content">
          <div class="invoice-signature__space"></div>
          <hr class="special-hr" />
          <div>{{ currentUserPersonalInfo.name }}</div>
        </div>
      </div>
      <div class="invoice-print-meta">
        <span v-if="data.guarantee_reference"
          >Referensi penjamin: {{ data.guarantee_reference }}</span
        >
        <span
          >Dicetak {{ printTime
          }}<template v-if="data.created_by_name">
            · Kasir: {{ data.created_by_name }}</template
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageComponent from "@/component/general/ImageComponent.vue";

export default {
  props: {
    data: Object,
    height: String,
    width: String,
    isPrint: Boolean,
    setting: Object,
    items: Array,
    renderNotes: Boolean,
    showSummary: Boolean,
    notes: String,
  },

  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    printTime() {
      return new Date().toLocaleString("id-ID", {
        dateStyle: "medium",
        timeStyle: "short",
      });
    },

    mutated_total_amount: {
      set(newValue) {
        this.data.total_amount = newValue;
      },
      get() {
        let amount = this.data.total_amount;
        this.items.forEach((value) => {
          amount += value.discount_amount * value.quantity;
        });
        return amount;
      },
    },

    mutated_final_amount: {
      set(newValue) {
        this.data.final_amount = newValue;
      },
      get() {
        let amount = this.data.final_amount;
        this.items.forEach((value) => {
          amount += value.discount_amount * value.quantity;
        });
        return amount;
      },
    },
  },

  components: {
    ImageComponent,
  },

  data() {
    return {
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Keterangan",
        },
        {
          key: "quantity",
          label: "Jumlah",
          thStyle: { width: "5%" },
        },
        {
          key: "discount",
          label: "Diskon",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "price",
          label: "Harga",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "subtotal",
          label: "Subtotal",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
    };
  },
  methods: {
    numberValue(value) {
      const n = Number(value || 0);
      return Number.isFinite(n) ? n : 0;
    },
  },
};
</script>

<style scoped>
.special-hr {
  border-color: #000000;
  border-style: solid;
  border-width: 2px 0 0;
  clear: both;
  margin: 0 0 0px;
  height: 0;
}

.invoice-content {
  min-height: 0;
}

.card-body {
  position: relative;
  overflow: hidden;
}
.invoice-document-meta {
  position: absolute;
  z-index: 3;
  top: 9px;
  right: calc(25% + 12px);
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: flex-end;
}
.invoice-status-stamp,
.invoice-copy-stamp {
  padding: 5px 9px;
  border: 2px solid currentColor;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.08em;
  transform: rotate(-2deg);
}
.invoice-copy-stamp {
  color: #586b82;
  transform: rotate(2deg);
}
.tone-success {
  color: #138451;
}
.tone-warning {
  color: #b66b00;
}
.tone-danger {
  color: #d63f46;
}
.tone-info {
  color: #116d91;
}
.tone-neutral {
  color: #65758a;
}
.invoice-watermark {
  position: absolute;
  z-index: 0;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-28deg);
  opacity: 0.055;
  font-size: 48px;
  font-weight: 900;
  letter-spacing: 0.08em;
  white-space: nowrap;
  pointer-events: none;
}
.card-body > *:not(.invoice-watermark):not(.invoice-document-meta) {
  position: relative;
  z-index: 1;
}
.invoice-print-meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  color: #68788c;
  font-size: 8px;
}

.invoice-notes-box {
  width: 255px;
  height: 68px;
  padding: 5px 7px;
  overflow: hidden;
  border: 1.5px solid rgb(196, 196, 196);
  border-radius: 7px;
}

.invoice-closing-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  align-items: start;
  gap: 18px;
  margin-top: 10px;
}

.invoice-notes-box {
  margin-top: 5px;
}

.invoice-summary {
  width: 220px;
  margin-top: 20px;
}

.invoice-summary td:first-child {
  width: 120px !important;
}

.invoice-total-row td,
.invoice-total-row span {
  font-weight: 800 !important;
}

.invoice-signature {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding: 0 28px 8px 0;
  page-break-inside: avoid;
}

.invoice-signature__content {
  min-width: 150px;
  text-align: center;
}

.invoice-signature__space {
  height: 44px;
}

.invoice-signature .special-hr {
  margin: 0 0 4px;
}
</style>
